import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { getRole } from 'utils/common';

const isActive = (items, pathname) => !!items?.some((item) => item.url === pathname || isActive(item.children, pathname));

const OPEN_GROUPS_KEY = 'sidebar_open_groups';
const DEFAULT_OPEN_GROUPS = ['workspace', 'services'];

const readOpenGroups = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(OPEN_GROUPS_KEY));
    return Array.isArray(stored) ? stored : DEFAULT_OPEN_GROUPS;
  } catch {
    return DEFAULT_OPEN_GROUPS;
  }
};

// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
  const role = getRole();
  const chatLink = localStorage.getItem('chat_link');
  const { pathname } = useLocation();

  const filterItems = (items) =>
    items
      .filter((item) => (item.minRole || 0) <= role)
      .filter((item) => item.id !== 'chat' || chatLink)
      .map((item) => (item.children ? { ...item, children: filterItems(item.children) } : item));

  const visibleGroups = menuItem.items
    .map((item) => {
      if (item.type !== 'group' || (item.minRole || 0) > role) {
        return null;
      }
      const children = filterItems(item.children);
      return children.length > 0 ? { ...item, children } : null;
    })
    .filter(Boolean);

  const activeGroupId = visibleGroups.find((group) => isActive(group.children, pathname))?.id;
  const [openGroupIds, setOpenGroupIds] = useState(readOpenGroups);

  useEffect(() => {
    localStorage.setItem(OPEN_GROUPS_KEY, JSON.stringify(openGroupIds));
  }, [openGroupIds]);

  // navigating only ever opens the group that owns the route, never closes the others
  useEffect(() => {
    if (activeGroupId) {
      setOpenGroupIds((prev) => (prev.includes(activeGroupId) ? prev : [...prev, activeGroupId]));
    }
  }, [pathname, activeGroupId]);

  const toggleGroup = (id) => {
    setOpenGroupIds((prev) => (prev.includes(id) ? prev.filter((groupId) => groupId !== id) : [...prev, id]));
  };

  return (
    <>
      {visibleGroups.map((item, index) => (
        <NavGroup
          key={item.id}
          item={item}
          first={index === 0}
          active={item.id === activeGroupId}
          open={openGroupIds.includes(item.id)}
          onToggle={() => toggleGroup(item.id)}
        />
      ))}
    </>
  );
};

export default MenuList;
